import React from "react";
import "./Multimedia_Services_info.css";

function Multimedia_Services_info(props) {


  return (
    <>
      <section className="Multimedia_Services_info Video_Wala_Bus_Stand">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-7 col-md-7 col-sm-7   order-sm-1 order-2  p-0">
              <div className="text-content">
                <div>
                  <h4>{props?.Heading_1}</h4>

                  <div className="p_tag_div">
                    <p>
                    {props?.desc_1}
                    </p>
                  </div>
                </div>

                <hr className="hr_line_holder" />
                <div>
                  <h4>{props?.Heading_2}</h4>

                  <div className="second_p_tag_div">
                    <p>
                    {props?.desc_2}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-5 col-md-5  col-sm-5 col-6  order-sm-2 order-1 p-0 video_col_holder">
              <div className="img-holder">
                <img
                  className="vdo-wala-inner-img"
                  src= {props?.imgSrc}
                  alt="vdo-wala-inner-img"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Multimedia_Services_info;
